/**
 * Eckpunkt Branding Configuration
 * Erweiterte Theme- und Design-Konfiguration
 */
/**
 * Eckpunkt Restaurant Branding
 */
export const eckpunktBranding = {
    colors: {
        // Primary - Eckpunkt Red
        primary: '#DC2626', // red-600
        primaryHover: '#B91C1C', // red-700
        // Secondary - Neutral slate
        secondary: '#64748B', // slate-500
        secondaryHover: '#475569', // slate-600
        // Accent - Eckpunkt Red (for highlights)
        accent: '#DC2626', // red-600
        accentHover: '#B91C1C', // red-700
        // Semantic colors
        success: '#16A34A', // green-600 - for confirmations, additions
        successHover: '#15803D', // green-700
        danger: '#DC2626', // red-600 - for removals, errors (same as primary)
        dangerHover: '#B91C1C', // red-700
        warning: '#EA580C', // orange-600 - for warnings, alerts
        warningHover: '#C2410C', // orange-700
        info: '#0284C7', // sky-600 - for info, tooltips
        infoHover: '#0369A1', // sky-700
        // Background colors
        background: '#FFFFFF', // white
        surface: '#F8FAFC', // slate-50 - cards, panels
        surfaceHover: '#F1F5F9', // slate-100
        // Text colors
        textPrimary: '#0F172A', // slate-900 - main text
        textSecondary: '#475569', // slate-600 - secondary text
        textMuted: '#94A3B8' // slate-400 - muted text, placeholders
    },
    // ✅ Cart-specific styling configuration
    cart: {
        header: {
            // Option 1: Use gradient (default) - Elegant gray gradient
            backgroundGradient: {
                from: '#475569', // slate-600 - elegant gray
                to: '#334155', // slate-700 - darker gray
                direction: 'to right'
            },
            // Option 2: Use solid color (uncomment to override gradient)
            // background: '#475569',
            textColor: '#FFFFFF', // white text
            badgeBackground: 'rgba(255, 255, 255, 0.2)', // semi-transparent white
            badgeTextColor: '#FFFFFF' // white badge text
        },
        footer: {
            checkoutButtonColor: '#DC2626', // red-600 (Eckpunkt Primary)
            checkoutButtonHover: '#B91C1C', // red-700 (Eckpunkt Primary Hover)
            checkoutButtonText: '#FFFFFF' // white text
        }
    },
    borderRadius: '0.5rem', // 8px - consistent rounded corners
    fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
    spacing: {
        small: '0.5rem', // 8px
        medium: '1rem', // 16px
        large: '1.5rem' // 24px
    },
    componentStyles: {
        productCard: {
            defaultVariant: 'menu-card',
            variants: {
                'menu-card': {
                    wrapper: 'group relative flex-1 min-w-0 max-w-sm basis-80 sm:basis-96 flex-shrink-0',
                    card: 'flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-lg border border-gray-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl cursor-pointer',
                    imageWrapper: 'relative h-64 bg-gray-50 overflow-hidden',
                    image: 'w-full h-full object-cover transition-transform duration-500 group-hover:scale-105',
                    placeholder: 'absolute inset-0 bg-gray-100 flex items-center justify-center text-gray-500 font-semibold text-xs tracking-wide uppercase',
                    content: 'flex flex-1 flex-col gap-3 p-6',
                    infoStack: 'flex flex-col gap-2',
                    titleRow: 'flex items-start justify-between gap-3',
                    title: 'text-xl font-bold text-gray-900 leading-tight line-clamp-2',
                    price: 'text-red-600 font-bold text-lg whitespace-nowrap',
                    originalPrice: 'text-sm text-gray-400 line-through',
                    description: 'text-sm text-gray-600 line-clamp-3 min-h-[3.5rem]',
                    footer: 'mt-auto flex items-center justify-between pt-4 border-t border-gray-100',
                    category: 'flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-gray-400',
                    button: 'inline-flex items-center gap-2 rounded-full bg-red-600 px-5 py-2 text-white text-sm font-semibold transition-all duration-200 hover:bg-red-700 hover:shadow-xl',
                    badges: {
                        leftBase: 'absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-semibold shadow-md shadow-gray-900/10 uppercase tracking-wide bg-white/90 text-gray-900',
                        rightBase: 'absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-semibold shadow-md shadow-gray-900/10 uppercase tracking-wide bg-white/90 text-gray-900',
                        discount: 'bg-red-600 text-white',
                        popular: 'bg-amber-400 text-gray-900',
                        sale: 'bg-gray-900 text-white'
                    }
                }
            }
        }
    }
};
export default eckpunktBranding;
